import React from 'react';
import markdownContent from '!!raw-loader!static/resilience_health_requirements.md';
import { Markdown } from 'Common';

export function ResilienceRequirements() {
  return <Markdown className="popup" containerId="modal-body" scrollOffset={0}>{markdownContent}</Markdown>;
}
